<svg class="cds-block cds-m-auto" [attr.width]="totalWidth" [attr.height]="height" [attr.viewBox]="viewBox">
  <defs>
    <pattern [attr.id]="'pie-pattern-diagonal-' + instanceId"
         patternUnits="userSpaceOnUse"
         width="8"
         height="14"
         patternTransform="rotate(45)">
      <rect width="14" height="14" fill="white"/>
      <line x1="0" y1="0" x2="0" y2="14" stroke="#7A8CA5" stroke-width="6"/>
    </pattern>
    <pattern [attr.id]="'pie-pattern-dots-' + instanceId"
         patternUnits="userSpaceOnUse"
         width="8"
         height="8">
      <rect width="8" height="8" fill="white"/>
      <circle cx="4" cy="4" r="3" fill="none" stroke="#7A8CA5" stroke-width="1.2"/>
    </pattern>
  </defs>

  @if (paths && paths.length > 0 && !emptyResponse) {
    @if (showLegend) {
      @for (item of legendItems; track $index) {
        <rect
          [attr.x]="8"
          [attr.y]="legendStartY + $index * 22"
          width="14" height="14"
          [attr.fill]="item.patternId ? 'url(#' + item.patternId + '-' + instanceId + ')' : item.color"
          rx="2"/>
        <text
          [attr.x]="28"
          [attr.y]="legendStartY + $index * 22 + 11"
          font-size="13"
          [attr.style]="'font-family: Lato, sans-serif'"
          fill="#1A1A2E"
          text-rendering="geometricPrecision">{{item.label}}</text>
      }
    }

    <g [attr.transform]="chartTransform">
      @for (sector of paths; track $index) {
        <path class="cds-cursor-pointer"
          [attr.d]="sector.d"
          [attr.fill]="sector.patternId ? 'url(#' + sector.patternId + '-' + instanceId + ')' : sector.color"
          stroke="white" stroke-width="2"
          (click)="getFilterData(sector.label)"></path>
        <text (click)="getFilterData(sector.label)"
          [attr.y]="sector.lY + 6"
          [attr.x]="sector.lX"
          text-anchor="middle"
          font-size="13"
          font-weight="700"
          [attr.style]="'font-family: Lato, sans-serif'"
          text-rendering="geometricPrecision"
          stroke-width="2"
          stroke="black"
          paint-order="stroke"
          fill="white">
          {{ sector.percent }}%
        </text>
      }
    </g>
  } @else {
    <circle
      [attr.cx]="chartCx"
      [attr.cy]="height / 2"
      [attr.r]="height * 0.36"
      fill="#F4F4F4" stroke="#ADB7CD"></circle>
    <text
      [attr.x]="chartCx"
      [attr.y]="height / 2"
      text-anchor="middle"
      dominant-baseline="middle"
      font-size="12"
      font-weight="400"
      font-family="Lato"
      fill="#6F7175">
      <tspan>There are no</tspan>
      <tspan [attr.x]="chartCx" dy="1.2em">pending policies</tspan>
    </text>
  }
</svg>
